import React from 'react'
import StepTitle from '../StepTitle/StepTitle'
import MealCustomizeOption from '../../Meal/MealCustomizeOption';
import SelectAddOnData from '../../../utils/CustomizedCalculation/SelectAddOnData';
import ItemOption from '../ItemOption/ItemOption';
import { useTranslation } from 'react-i18next';

interface addOnProps {
    selectAddOn: any,
    setSelectedAddOn: any,
    addon_data: any,
    refrencePage?: any
}
const AddOnData = ({ selectAddOn, setSelectedAddOn, addon_data, refrencePage }: addOnProps) => {
   const {t} = useTranslation()
   
    return (
        <>
            {addon_data?.length > 0 && <>
                <StepTitle stepTitle={t("Home.addOns")} err={false} />

                {addon_data?.map((addOnItem: any, addOnIndex: number) => {
                    let isChecked = selectAddOn?.find((i: any) => i?.addon_item_id == addOnItem?.addon_item_id) ? true : false
                    let propsDataObj = {
                        defaultChecked: isChecked,
                        key: addOnIndex,
                        id: addOnItem?.addon_item_id,
                        itemName: addOnItem?.addon_item?.name,
                        price: addOnItem?.web_offered_price ? addOnItem?.web_offered_price : 0
                    }

                    return refrencePage == 'MealCustomizeData' ? <MealCustomizeOption
                        {...propsDataObj}
                        key={addOnIndex}
                        onchange={(e: any) => SelectAddOnData({ e, addOnItem, itemAddOnAllData: addon_data, selectAddOn, setSelectedAddOn })}
                    /> : <ItemOption
                        {...propsDataObj}
                          key={addOnIndex}
                        onchange={(e: any) => SelectAddOnData({ e, addOnItem, itemAddOnAllData: addon_data, selectAddOn, setSelectedAddOn })}

                    />
                })}

            </>}
        </>
    )
}

export default AddOnData